import type { MetaFunction } from "react-router";
import { HeroSection } from '../components/Home/HeroSection';
import { AboutSection } from '../components/Home/AboutSection';
import { ServicesSection } from '../components/Home/ServicesSection';
import { ContactSection } from '../components/Home/ContactSection';

export const meta: MetaFunction = () => {
  const structuredData = {
    "@context": "https://schema.org",
    "@type": "LocalBusiness",
    "name": "Mgr. Hana Jarkovská - Psychoterapie a etopedické poradenství",
    "description": "Psychoterapie a etopedické poradenství v Bílovci. Integrativní přístup, terapie pro děti, dospívající, dospělé i rodiny.",
    "url": "https://www.hanajarkovska.cz",
    "telephone": "+420797677397",
    "email": "hana.jarkovska@etoped.cz",
    "image": "https://www.hanajarkovska.cz/img/profil1.webp",
    "address": {
      "@type": "PostalAddress",
      "addressLocality": "Bílovec",
      "postalCode": "743 01",
      "addressCountry": "CZ"
    },
    "geo": {
      "@type": "GeoCoordinates",
      "latitude": "49.7564",
      "longitude": "18.0149"
    },
    "priceRange": "$$",
    "areaServed": [
      { "@type": "City", "name": "Bílovec" },
      { "@type": "City", "name": "Nový Jičín" },
      { "@type": "City", "name": "Ostrava" },
      { "@type": "AdministrativeArea", "name": "Moravskoslezský kraj" }
    ],
    "availableLanguage": ["cs"],
    "serviceType": ["Psychoterapie", "Etopedické poradenství", "Rodinná terapie", "Terapie pro děti", "Krizová intervence"],
    "founder": {
      "@type": "Person",
      "name": "Hana Jarkovská",
      "jobTitle": "Etoped, Reflektant výcviku v integrativní psychoterapii"
    },
    "openingHoursSpecification": {
      "@type": "OpeningHoursSpecification",
      "dayOfWeek": ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday"],
      "opens": "09:00",
      "closes": "18:00"
    }
  };

  return [
    { tagName: "link", rel: "canonical", href: "https://www.hanajarkovska.cz/" },
    { title: "Mgr. Hana Jarkovská — Psychoterapie a etopedické poradenství" },
    { name: "description", content: "Psychoterapie a etopedické poradenství v Bílovci. Bezpečný prostor pro porozumění, změnu a klid s důrazem na respekt a lidskost. Online i osobní konzultace." },
    { name: "keywords", content: "psychoterapie Bílovec, etoped Bílovec, etopedické poradenství, psychoterapeut Nový Jičín, terapie pro děti, rodinná terapie, poruchy chování, výchovné problémy, integrativní psychoterapie, online konzultace" },
    { name: "author", content: "Mgr. Hana Jarkovská" },
    { property: "og:type", content: "website" },
    { property: "og:url", content: "https://www.hanajarkovska.cz/" },
    { property: "og:title", content: "Mgr. Hana Jarkovská — Psychoterapie a etopedické poradenství" },
    { property: "og:description", content: "Psychoterapie a etopedické poradenství v Bílovci. Bezpečný prostor pro porozumění, změnu a klid s důrazem na respekt a lidskost." },
    { property: "og:image", content: "https://www.hanajarkovska.cz/img/profil1.webp" },
    { property: "og:locale", content: "cs_CZ" },
    { name: "twitter:card", content: "summary_large_image" },
    { name: "twitter:title", content: "Mgr. Hana Jarkovská — Psychoterapie a etopedické poradenství" },
    { name: "twitter:description", content: "Psychoterapie a etopedické poradenství v Bílovci. Bezpečný prostor pro porozumění, změnu a klid s důrazem na respekt a lidskost." },
    { name: "twitter:image", content: "https://www.hanajarkovska.cz/img/profil1.webp" },
    { "script:ld+json": structuredData },
  ];
};

export default function HomePage() {
  return (
    <>
      <HeroSection />
      <AboutSection />
      <ServicesSection />
      <ContactSection />
    </>
  );
}
